import type { PositionLeg } from './types';

export type PositionRollup = {
  quantity: number;
  avg_price: number | null;
};

/** Weighted average cost: Σ(qi×pi) / Σ qi. Null avg when any leg lacks a price. */
export function rollupPositions(
  legs: readonly PositionLeg[],
  opts?: { cashEq?: boolean }
): PositionRollup {
  if (legs.length === 0) {
    throw new Error('at least one position is required');
  }

  let quantity = 0;
  let cost = 0;
  let allPriced = true;

  for (const leg of legs) {
    if (!Number.isFinite(leg.quantity) || leg.quantity <= 0) {
      throw new Error('each position quantity must be a positive number');
    }
    quantity += leg.quantity;

    if (opts?.cashEq) {
      // Stablecoins: quantity-only; avg_price is fixed/ignored.
      continue;
    }

    if (leg.avg_price == null) {
      allPriced = false;
      continue;
    }
    if (!Number.isFinite(leg.avg_price) || leg.avg_price <= 0) {
      throw new Error('each position avg_price must be a positive number or empty');
    }
    cost += leg.quantity * leg.avg_price;
  }

  if (opts?.cashEq) {
    return { quantity, avg_price: null };
  }

  return {
    quantity,
    avg_price: allPriced && quantity > 0 ? cost / quantity : null,
  };
}
